module.exports = __webpack_public_path__ + "static/media/IHM-Milestone.82fa0de0.jpg";